import React from 'react';
import CreatorInfo from '../common/CreatorInfo';

/**
 * ToolInfoTable Component
 * 
 * Displays tool metadata in the exact same table format as the legacy HTML site.
 */
const ToolInfoTable = ({ toolInfo }) => {
  if (!toolInfo || Object.keys(toolInfo).length === 0) return null;

  return (
    <div className="tool-table-wrap">
      <table id="tool-table">
        <tbody>
          <tr>
            <th colSpan="3">Tool Info</th>
          </tr>
          
          {/* Category - only show if present */}
          {toolInfo.category && (
            <tr>
              <td>Category</td>
              <td>{toolInfo.category}</td>
            </tr>
          )}
          
          {/* Updated date - only show if present */}
          {toolInfo.updated && (
            <tr>
              <td>Updated</td>
              <td>{toolInfo.updated}</td>
            </tr>
          )}
          
          {/* Templates (resources) - if present */}
          {toolInfo.templates && (
            <tr>
              <td>Templates</td>
              <td>
                {toolInfo.templates}
              </td>
            </tr>
          )}
          
          {/* Creator - with optional link */}
          {toolInfo.creator && (
            <tr>
              <td>Creator</td>
              <td>
                <CreatorInfo creator={toolInfo.creator} />
              </td>
            </tr>
          )}
          
          {/* Tags - only show if present */}
          {toolInfo.tags && toolInfo.tags.length > 0 && (
            <tr>
              <td>Tags</td>
              <td>
                {toolInfo.tags.map((tag, index) => (
                  <span key={`tag-${index}`}>
                    {tag}
                    {index < toolInfo.tags.length - 1 ? ', ' : ''}
                  </span>
                ))}
              </td>
            </tr>
          )}
          
          {/* Any additional fields that might be present */}
          {Object.entries(toolInfo).map(([key, value]) => {
            // Skip fields we've already handled
            if (['updated', 'category', 'creator', 'tags', 'templates'].includes(key)) {
              return null;
            }
            
            // Handle objects or strings
            let displayValue;
            if (typeof value === 'object' && value !== null) {
              if (value.href) {
                displayValue = (
                  <a 
                    href={value.href} 
                    className="link-table"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {value.text || value.href}
                  </a>
                );
              } else {
                displayValue = JSON.stringify(value);
              }
            } else {
              displayValue = value;
            }
            
            return (
              <tr key={`info-${key}`}>
                <td>{capitalizeFirstLetter(key)}</td>
                <td>{displayValue}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

/**
 * Helper function to capitalize the first letter of a string
 */
const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export default ToolInfoTable; 